function addCreditCardInputMask(elements) {
  elements.inputmask('aaaa-aaaa-aaaa-aaaa', {
    placeholder: ' ',
  });
}

function init() {
  addCreditCardInputMask($('[data-gift-card-token-input]'));
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./src/components/legacy/gift_cards/redeem.js